import { E_Session_PaymentState, E_Session_State, E_Session_Type } from "./constants/Enums_Session";

/**
 *
 * @type {{
 *  notes: string,
 *  voucher: {},
 *  reservedFrom: Date,
 *  startedAt: Date,
 *  invoiceEmail: string,
 *  createdOn: number,
 *  pin: string,
 *  deliveryContinuation: {},
 *  sessionType: E_Session_Type,
 *  tariff: {},
 *  id: number,
 *  state: E_Session_State,
 *  paymentState: E_Session_PaymentState,
 *  cost: {},
 *  reservedTo: Date,
 *  limitedTime: Date,
 *  deliveryPrice: {},
 *  paymentResponseText: string,
 *  cardNumbers: string[],
 *  phone: string,
 *  pickupAddress: string,
 *  endedAt: Date,
 *  service: {},
 *  timeBracket: {},
 *  location: {},
 *  user: {},
 *  invoiceAvailable: boolean,
 * }}
 */
export const M_Session = {
	id: undefined,
	createdOn: undefined,
	state: E_Session_State.PENDING,
	paymentState: E_Session_PaymentState.PENDING,
	paymentResponseText: null,
	pin: null,
	startedAt: null,
	limitedTime: null,
	endedAt: null,
	reservedFrom: null,
	reservedTo: null,
	user: {},
	service: {},
	location: {},
	cost: {},
	timeBracket: {},
	cardNumbers: [],
	invoiceEmail: null,
	phone: null,
	invoiceAvailable: true,
	tariff: {},
	voucher: {},
	notes: null,
	deliveryContinuation: {},
	deliveryPrice: {},
	sessionType: E_Session_Type.REGULAR,
	pickupAddress: null,
};
